export default __webpack_public_path__ + "static/media/Logo-Banner_mobile.cff0bc06.png";